module.exports = __webpack_public_path__ + "img/link.733412ae.jpg";